import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useIdleTimer from '../hooks/useIdleTimer';

import instructionsWheelEn from '../assets/images/instructions-wheel_en.png';
import instructionsWheelFr from '../assets/images/instructions-wheel_fr.png';
import pattern from '../assets/images/pattern.png';

import Button from '../components/Button';

const Instruction = () => {
  const device = localStorage.getItem('device');

  const { i18n, t } = useTranslation();

  const { time } = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    const startTime = new Date().toLocaleString();
    const startTimeISO = new Date().toISOString();

    time.setStartTime(startTime);

    localStorage.setItem('start-time', startTime);
    localStorage.setItem('start-time-iso', startTimeISO);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useIdleTimer();

  return (
    <div
      onClick={() => {
        device === 'kiosk' ? navigate('/data-entry') : navigate('/data-entry-mobile');
      }}
    >
      <div className="_gradient-border lg:text-6xl text-[2.2rem] text-center w-[80%] lg:p-16 p-4 mx-auto lg:mt-[12rem] md:mt-10 mt-6 relative z-20">
        <h3 className="lg:text-7xl text-brandAccent pt-4">{t('instructions')}</h3>
        <p className="md:text-4xl lg:text-6xl text-xl lg:mt-20 mt-4">{t('instruction1')}</p>
        <div className="md:px-10 md:py-8 py-4">
          <img
            src={i18n.language === 'en' ? instructionsWheelEn : instructionsWheelFr}
            alt="instructions_wheel"
            className="w-[28%] mx-auto"
          />
        </div>
        <p className="md:text-4xl lg:text-6xl text-xl lg:mt-10">{t('instruction2')}</p>
        <p className="md:text-4xl lg:text-6xl text-xl lg:my-20 my-4">{t('instruction3')}</p>

        <Button>{t('next')}</Button>
      </div>

      <img src={pattern} alt="pattern" className="lg:w-full w-[60%] absolute bottom-0 left-0" />
    </div>
  );
};

export default Instruction;
